import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
  titleClassName?: string;
};

export function PageHeader({ title, subtitle, actions, className, titleClassName }: PageHeaderProps) {
  return (
    <div className={cn('thms-page-header', className)}>
      <div>
        <h1 className={cn('thms-page-title', titleClassName)}>{title}</h1>
        {subtitle ? <p className="thms-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
    </div>
  );
}
